import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import estilos from '../Asociados/PanelAsociadoComponent.module.css'

import { getInstalacionesByCliente } from '../../../redux/DucksUnidadInspeccion/AsociadosDuck';
import { ObtenerClientes, obtenerClienteConDetalle, obtenerClienteConDetalleByNumeroSocio } from '../../../redux/DucksAtencionACliente/ModuloConsultaDucks'
import { getAllInformes, insertInforme } from '../../../redux/DucksUnidadInspeccion/InformeCumplimientoDuck';

function TableInstalacionesComponent(props) {

    //console.log(JSON.stringify(clientes))
    const clientes = useSelector(store => store.ModuloConsulta.clientes);
    const instalaciones = useSelector(store => store.Asociado.instalaciones);
    const informes = useSelector(store => store.Informe.informe);

    const [cajaBusqueda, setcajaBusqueda] = React.useState('');
    const [clientesFiltrados, setClientesFiltrados] = React.useState([]);
    const [clienteSeleccionado, setClienteSeleccionado] = React.useState(1);
    const [opcionesOcultas, setOpcionesOcultas] = React.useState(true);
    const [resultadoBusqueda, setResultadoBusqueda] = React.useState(true);
    const [dictaminadas, setDictaminadas] = React.useState([]);

    const dispatch = useDispatch()

    React.useEffect(() => {
        dispatch(ObtenerClientes())   //clientes
        dispatch(getAllInformes())   //clientes       
    }, []);

    const handleSetCliente = (instalacion, idclienteSeleccionado, idinformaciongeneralcliente, alias) => {

        const data = {
            data: {
                idiformaciongeneralcliente: idinformaciongeneralcliente,
                idcliente: idclienteSeleccionado
            }
        }

        console.log(data)

        dispatch(insertInforme(data))   //agregar informe

        props.history.push("/PanelInspeccion", {
            state: {
                idclienteSeleccionado,
                instalacion,
                alias,
                optionTab: 1

            }
        });
    }

    const handleSetInstalacionSeguimiento = (instalacion, idclienteSeleccionado, idinformaciongeneralcliente, alias) => {
        props.history.push("/PanelInspeccion", {
            state: {
                idclienteSeleccionado: idclienteSeleccionado,
                instalacion: instalacion,
                alias: alias,
                optionTab: 2
            }
        });
    }

    const handleElegirCliente = (cliente) => {
        if (cajaBusqueda != '') {
            setcajaBusqueda(cliente.nombrerazonsocial);
            setClienteSeleccionado(cliente);
            dispatch(getInstalacionesByCliente(cliente.idcliente));
        } else {
            alert('Ingrese un número de cliente o razón social');
        }
    }


    React.useEffect(() => {
        if (cajaBusqueda != '') {
            setOpcionesOcultas(false);
            //DOS CASOS
            //|1| SI ES POR NÚMERO DE SOCIO
            if (!isNaN(cajaBusqueda)) {
                setClientesFiltrados(clientes?.filter(c => c.numerosocio.toUpperCase().includes(cajaBusqueda.toUpperCase())));
            }
            else {
                //|2| SI ES POR RAZÓN SOCIAL
                setClientesFiltrados(clientes?.filter(c => c.nombrerazonsocial.toUpperCase().includes(cajaBusqueda.toUpperCase())));
            }
            if (clientesFiltrados.length > 0) {
                setClienteSeleccionado(clientesFiltrados[0]);
            }
        } else if (cajaBusqueda.length === 0) {
            setOpcionesOcultas(true);
        }
        else {
            instalaciones = []
        }

    }, [cajaBusqueda])

    React.useEffect(() => {
        let dict = []
        if (instalaciones.length > 0) {
            if (informes.length > 0) {
                informes.forEach((element) => {
                    instalaciones.forEach((instalacion) => {
                        if (element.idiformaciongeneralcliente === instalacion.idiformaciongeneralcliente) {
                            dict.push(instalacion)
                        }
                    })
                })
            }
            let result = dict.filter((item, index) => {
                return dict.indexOf(item) === index;
            })

            setDictaminadas(result)
        }

    }, [informes])

    React.useEffect(() => {
        dictaminadas
    }, [dictaminadas])

    React.useEffect(() => {
        let dict = []
        if (informes.length > 0) {
            informes.forEach((element) => {
                instalaciones.forEach((instalacion) => {
                    if (element.idiformaciongeneralcliente === instalacion.idiformaciongeneralcliente) {
                        dict.push(instalacion)
                    }
                })
            })
        }
        let result = dict.filter((item, index) => {
            return dict.indexOf(item) === index;
        })

        setDictaminadas(result)

    }, [instalaciones])

    const handleBuscarInstalaciones = (event) => {
        setcajaBusqueda(event.target.value);
    }
    return (
        <Fragment><br />
            <div className='row'>
                <div>
                    <div className="d-flex" role="search">
                        <input className="form-control me-2" type="search" name='busqueda'
                            placeholder="Ingrese el número de cliente o razón social ..."
                            aria-label="Search" onChange={handleBuscarInstalaciones} value={cajaBusqueda} />
                    </div>

                    <div hidden={opcionesOcultas}>

                        {
                            clientesFiltrados.map((i, index) => (

                                <p className={`${estilos.opciones}`} onClick={() => handleElegirCliente(i)} key={index}><strong>( {i.numerosocio} )</strong> {i.nombrerazonsocial}</p>
                            ))
                        }
                    </div>
                </div>
                <br />
                <hr />

                <p>Instalaciones del cliente: <strong>( {clienteSeleccionado.numerosocio} ) </strong>  {clienteSeleccionado.nombrerazonsocial}</p>
                <div className='table-responsive'>
                    <table className='table table-striped table-hover'>
                        <thead>
                            <tr>
                                <th>Instalación:</th>
                                <th>Alias:</th>
                                <th>Domicilio:</th>
                                <th>Tipo de Instalación:</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                instalaciones.map((i, index) => {
                                    return (
                                        <Fragment key={index} >
                                            <tr >
                                                <td>{i.informaciongeneralinstalacioncliente.instalacionnumero}</td>
                                                <td>{i.informaciongeneralinstalacioncliente.alias}</td>
                                                <td>{i.informaciongeneralinstalacioncliente.calle}&nbsp;
                                                    {i.informaciongeneralinstalacioncliente.numeroexterior}&nbsp;
                                                    {i.informaciongeneralinstalacioncliente.numerointerior}&nbsp;
                                                    {i.informaciongeneralinstalacioncliente.colonia}&nbsp;
                                                    {i.informaciongeneralinstalacioncliente.localidad}&nbsp;
                                                    {i.informaciongeneralinstalacioncliente.municipio}
                                                </td>
                                                <td><p>{

                                                    i.idtipoanexo === 1 ? (
                                                        <strong>Unidad de Producción</strong>

                                                    ) :
                                                        i.idtipoanexo === 2 ? (
                                                            <strong>Unidad de Envasado</strong>

                                                        ) :
                                                            i.idtipoanexo === 3 ? (
                                                                <strong>Unidad de Almacén</strong>

                                                            ) :
                                                                <></>

                                                }</p></td>

                                                {/* {dictaminadas.includes(i) ?
                                                    <td><button key={index} className='btn btn-success' onClick={() => {
                                                        handleSetInstalacionSeguimiento(i.informaciongeneralinstalacioncliente.instalacionnumero, i.idcliente, i.informaciongeneralinstalacioncliente.idiformaciongeneralcliente, i)
                                                    }}>Seguimiento</button></td>
                                                    :
                                                    <td><button key={index} className='btn btn-success' onClick={() =>
                                                        handleSetCliente(i.informaciongeneralinstalacioncliente.instalacionnumero, i.idcliente, i.informaciongeneralinstalacioncliente.idiformaciongeneralcliente, i)}>Dictaminar </button></td>

                                                } */}
                                            </tr>
                                        </Fragment>
                                    )

                                })
                            }
                        </tbody>
                    </table>
                </div>

            </div>

        </Fragment>
    );
};


export default withRouter(TableInstalacionesComponent)
